export const iconMap = {
    primary: "ui_checkmark",
    accent: "ui_checkmark",
    disabled: "ui_locked",
    error: "ui_error",
    alert: "ui_warning",
};
